import { create } from 'zustand'

interface ScriptStore {
  isAIGenerated: boolean
  setIsAIGenerated: (isAiGenerated: boolean) => void
  toggleAIGenerated: () => void

  promptName: string
  setPromptName: (name: string) => void

  toneName: string
  setToneName: (name: string) => void

  isModalOpen: boolean
  setModalOpen: (open: boolean) => void
  toggleModal: () => void
}

export const useScriptStore = create<ScriptStore>((set) => ({
  promptName: '',
  setPromptName: (name) => set({ promptName: name }),

  toneName: '',
  setToneName: (name) => set({ toneName: name }),

  isModalOpen: false,
  setModalOpen: (open) => set({ isModalOpen: open }),
  toggleModal: () => set((state) => ({ isModalOpen: !state.isModalOpen })),

  isAIGenerated: true,
  setIsAIGenerated: (isAIGenerated) => set({ isAIGenerated: isAIGenerated }),
  toggleAIGenerated: () =>
    set((state) => ({ isAIGenerated: !state.isAIGenerated })),
}))
